import { render } from "./DescPage.vue?vue&type=template&id=f08d47c4"
import script from "./DescPage.vue?vue&type=script&lang=js"
export * from "./DescPage.vue?vue&type=script&lang=js"

import "./DescPage.vue?vue&type=style&index=0&id=f08d47c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__